var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"pl-7 pr-7 pt-4 dark-bg-custom",attrs:{"items":_vm.employeeInventory,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.holdQty",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.remainingQtyHoldByUser(item))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }